// Integration data - upcoming integrations
const integrations = [
  {
    name: 'Samedi',
    industry: 'Medical',
    focus: 'Doctor appointments',
    authMethod: 'OAuth2 + API Key',
    apiBaseUrl: 'https://patient.samedi.de/api/booking/v3',
    addonTypes: ['chat', 'knowledge'],
    keyFeatures: 'Guest bookings, video consultations, PayPal integration',
    status: 'Upcoming'
  },
  {
    name: 'Doctolib',
    industry: 'Medical',
    focus: 'Healthcare platform',
    authMethod: 'Integration APIs',
    apiBaseUrl: 'Not public',
    addonTypes: ['chat', 'knowledge'],
    keyFeatures: 'Practice management, SCIM API, 290k+ specialists',
    status: 'Upcoming'
  },
  {
    name: 'Jameda',
    industry: 'Medical',
    focus: 'Doctor booking platform',
    authMethod: 'API + Google Integration',
    apiBaseUrl: 'Not public',
    addonTypes: ['chat'],
    keyFeatures: 'Google booking integration, PVS connections',
    status: 'Upcoming'
  },
  {
    name: 'Terminland',
    industry: 'Medical',
    focus: 'Rule-based appointments',
    authMethod: 'Basic + OAuth',
    apiBaseUrl: 'https://api.terminland.com',
    addonTypes: ['chat', 'knowledge'],
    keyFeatures: 'Video integration, payment processing, test enviroments',
    status: 'Upcoming'
  },
  {
    name: 'OpenTable',
    industry: 'Restaurant',
    focus: 'Restaurant reservations',
    authMethod: 'REST API',
    apiBaseUrl: 'https://platform.otrest.com/otrapi',
    addonTypes: ['chat'],
    keyFeatures: 'POS integration, consumer API, multi-location',
    status: 'Upcoming'
  },
  {
    name: 'Resmio',
    industry: 'Restaurant',
    focus: 'Restaurant management',
    authMethod: 'API + Google Integration',
    apiBaseUrl: 'https://api.resmio.com',
    addonTypes: ['chat', 'knowledge'],
    keyFeatures: 'Reserve with Google, POS integration, walk-in support',
    status: 'Upcoming'
  },
  {
    name: 'Bookingtime',
    industry: 'Business',
    focus: 'General appointments',
    authMethod: 'REST API',
    apiBaseUrl: 'https://api.bookingtime.com',
    addonTypes: ['chat', 'knowledge'],
    keyFeatures: '100% API-based, machine communication API, modular',
    status: 'Upcoming'
  },
  {
    name: 'Calendly',
    industry: 'Business',
    focus: 'Scheduling platform',
    authMethod: 'OAuth2',
    apiBaseUrl: 'https://api.calendly.com/v2',
    addonTypes: ['chat'],
    keyFeatures: 'Comprehensive API, webhook support, multi-language',
    status: 'Upcoming'
  },
  {
    name: 'Acuity Scheduling',
    industry: 'Business',
    focus: 'Appointment scheduling',
    authMethod: 'OAuth2 + Basic',
    apiBaseUrl: 'https://acuityscheduling.com/api/v1',
    addonTypes: ['chat', 'knowledge'],
    keyFeatures: 'JavaScript SDK, GitHub examples, enterprise features',
    status: 'Upcoming'
  },
  {
    name: 'Setmore',
    industry: 'Business',
    focus: 'Appointment booking',
    authMethod: 'OAuth2',
    apiBaseUrl: 'https://developer.setmore.com/api/v1',
    addonTypes: ['chat'],
    keyFeatures: '30+ languages, rate limiting, full CRUD operations',
    status: 'Upcoming'
  },
  {
    name: 'Shore',
    industry: 'Business',
    focus: 'German booking platform',
    authMethod: 'API Integration',
    apiBaseUrl: 'https://api.shore.com',
    addonTypes: ['chat', 'knowledge'],
    keyFeatures: 'Instagram/Facebook booking, Stripe integration, German support',
    status: 'Upcoming'
  },
  {
    name: 'MeeterGo',
    industry: 'Business',
    focus: 'GDPR-compliant scheduling',
    authMethod: 'API',
    apiBaseUrl: 'https://api.meetergo.com',
    addonTypes: ['chat', 'knowledge'],
    keyFeatures: 'German data hosting, 24/7 German support, GDPR compliance',
    status: 'Upcoming'
  },
  {
    name: 'Microsoft Bookings',
    industry: 'Business',
    focus: 'Microsoft 365 integration',
    authMethod: 'Microsoft Graph API',
    apiBaseUrl: 'https://graph.microsoft.com',
    addonTypes: ['chat', 'knowledge'],
    keyFeatures: 'Enterprise security, Power Automate, custom domains',
    status: 'Upcoming'
  },
  {
    name: 'YouCanBookMe',
    industry: 'Business',
    focus: 'Online booking',
    authMethod: 'HTTP Basic Auth',
    apiBaseUrl: 'https://api.youcanbook.me',
    addonTypes: ['chat'],
    keyFeatures: '44 languages, 100 country dialects, team plans',
    status: 'Upcoming'
  },
  {
    name: 'Altegio',
    industry: 'Beauty',
    focus: 'Salon management',
    authMethod: 'Open API + Webhooks',
    apiBaseUrl: 'https://api.altegio.com',
    addonTypes: ['chat', 'knowledge'],
    keyFeatures: 'Multi-location, payment integration, AI integration',
    status: 'Upcoming'
  },
  {
    name: 'Treatwell',
    industry: 'Beauty',
    focus: 'Salon booking platform',
    authMethod: 'API Integration',
    apiBaseUrl: 'https://api.treatwell.com',
    addonTypes: ['chat', 'knowledge'],
    keyFeatures: '40k+ professionals, marketplace integration, photography',
    status: 'Upcoming'
  },
  {
    name: 'SimplyBook.me',
    industry: 'Beauty',
    focus: 'Multi-industry booking',
    authMethod: 'API',
    apiBaseUrl: 'https://simplybook.me/api',
    addonTypes: ['chat'],
    keyFeatures: 'Unlimited services, payment integration, calendar sync',
    status: 'Upcoming'
  },
  {
    name: 'EasyWeek',
    industry: 'Beauty',
    focus: 'European salon booking',
    authMethod: 'API',
    apiBaseUrl: 'https://api.easyweek.io',
    addonTypes: ['chat', 'knowledge'],
    keyFeatures: 'Website creation, payment processing, multi-language',
    status: 'Upcoming'
  },
  {
    name: 'Salonkee',
    industry: 'Beauty',
    focus: 'Salon-specific booking',
    authMethod: 'API',
    apiBaseUrl: 'https://api.salonkee.com',
    addonTypes: ['chat', 'knowledge'],
    keyFeatures: 'Payment protection, automated communication, custom branding',
    status: 'Upcoming'
  },
  {
    name: 'Smoobu',
    industry: 'Hotel',
    focus: 'Accommodation booking',
    authMethod: 'REST API',
    apiBaseUrl: 'https://api.smoobu.com',
    addonTypes: ['chat', 'knowledge'],
    keyFeatures: 'Multi-channel integration, dynamic pricing, guest communication',
    status: 'Upcoming'
  },
  {
    name: 'Apaleo',
    industry: 'Hotel',
    focus: 'Property management',
    authMethod: 'API-first',
    apiBaseUrl: 'https://api.apaleo.com',
    addonTypes: ['chat', 'knowledge'],
    keyFeatures: 'Cloud-native, app marketplace, modern interface',
    status: 'Upcoming'
  },
  {
    name: 'Travelotopos',
    industry: 'Event',
    focus: 'Tour operator booking',
    authMethod: 'Channel Manager API',
    apiBaseUrl: 'https://api.travelotopos.com',
    addonTypes: ['chat', 'knowledge'],
    keyFeatures: 'Supplier integration, real-time availability, multi-language',
    status: 'Upcoming'
  }
];

export default integrations;






